<template>
  <div>
    <div class="page_title flex_between">
      <span>
        <span>用户积分明细</span>
      </span>
      <el-button type="primary"
                 style="width:92px;"
                 size="medium"
                 @click="back">返回</el-button>
    </div>
    <div style="padding:20px">
      <div class="container">
        <div class="info">
          <div style="display:flex">
            <div class="infoitem">
              <span class="infotitle">手机号：</span>
              <span>{{info.phone}}</span>
            </div>
            <div class="infoitem">
              <span class="infotitle">用户昵称：</span>
              <span>{{info.nick_name}}</span>
            </div>
            <div class="infoitem">
              <span class="infotitle">注册时间：</span>
              <span>{{info.reg_time}}</span>
            </div>

          </div>
        </div>
        <div class="pricebox">
          <div class="price">
            <div class="priceitem">
              <div class="gray">当前积分</div>
              <div class="num">{{info.integral?info.integral:0}}</div>
            </div>
            <div class="priceitem">
              <div class="gray">已用积分</div>
              <div class="num">{{info.use_integral?info.use_integral:0}}</div>
            </div>
            <div class="priceitem">
              <div class="gray">失效积分</div>
              <div class="num">{{info.expire_integral?info.expire_integral:0}}</div>
            </div>
          </div>
        </div>
        <el-tabs type="border-card"
                 v-model="activeName">
          <el-tab-pane label="积分变动表"
                       name="1"
                       :disabled="
                module_id_array[0] ? !module_id_array.includes('920') : false
              "></el-tab-pane>
          <el-tab-pane label="积分跟踪表"
                       name="2"
                       :disabled="
                module_id_array[0] ? !module_id_array.includes('922') : false
              "></el-tab-pane>
          <div class="box">
            <div class="component">
              <keep-alive>
                <component :is="currentComponent"
                           :userId="userId" />
              </keep-alive>
            </div>
          </div>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import IntegraChange from './IntegraChange.vue';
import IntegraFollow from './IntegraFollow.vue';
export default {
  data() {
    return {
      activeName: '1',
      userId: this.$route.query.user_id,
      info: {}
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case '1':
          return IntegraChange;
        case '2':
          return IntegraFollow;
        default:
          return IntegraChange;
      }
    }
  },
  methods: {
    getInfo() {
      let user_id = this.$route.query.user_id;
      this.axios
        .post('platform/Integral/getUserIntegralInfo', { user_id })
        .then((res) => {
          if (res.code == 0) {
            this.info = res.data.info;
            this.info.reg_time = dayjs
              .unix(this.info.reg_time)
              .format('YYYY-MM-DD HH:mm');
          }
        });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getInfo();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  min-height: calc(100vh - 140px);
}
.info {
  padding: 14px 0 14px 0px;
  text-align: left;
  .infoitem {
    margin-right: 40px;
    .infotitle {
      font-weight: 700;
    }
  }
}
.pricebox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #cfcece;
  border-radius: 2px;
  margin: 12px 0;
  .price {
    display: flex;
    align-items: center;
    .priceitem {
      border-right: solid 1px #e1e3e9;
      display: flex;
      align-items: center;
      padding: 0 30px;
    }
    .priceitem:before {
      content: '';
    }
  }
  .gray {
    font-size: 12px;
    color: #747981;
  }
  .num {
    font-size: 22px;
    font-weight: 700;
    margin-left: 20px;
  }
}
</style>